import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Card, CardContent, Button } from "@/components/ui";
import type { AttributeReviewCompleteStateProps } from "./AttributeReviewCompleteState.types";

export const AttributeReviewCompleteState: React.FC<
  AttributeReviewCompleteStateProps
> = ({ onBackToCatalog }) => {
  return (
    <Card>
      <CardContent className="py-12 text-center">
        <CheckCircle2 className="w-12 h-12 mx-auto mb-4 text-emerald-500" />
        <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-2">
          All Mappings Reviewed!
        </h3>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-4">
          You've reviewed all attribute mappings for this product type.
        </p>
        <Button variant="secondary" onClick={onBackToCatalog}>
          Back to Catalog Overview
        </Button>
      </CardContent>
    </Card>
  );
};
